/**
 * Session Manager for Analytics
 * Generates and manages session IDs for tracking user sessions
 */

const SESSION_STORAGE_KEY = 'analytics_session_id';
const SESSION_DURATION = 30 * 60 * 1000; // 30 minutes

export const getOrCreateSessionId = (): string => {
    let sessionId = sessionStorage.getItem(SESSION_STORAGE_KEY);
    const sessionTimestamp = sessionStorage.getItem(`${SESSION_STORAGE_KEY}_timestamp`);

    // Check if session exists and is still valid
    if (sessionId && sessionTimestamp) {
        const timestamp = parseInt(sessionTimestamp, 10);
        const now = Date.now();
        
        // If session is less than 30 minutes old, reuse it
        if (now - timestamp < SESSION_DURATION) {
            return sessionId;
        }
    }

    // Create new session
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId);
    sessionStorage.setItem(`${SESSION_STORAGE_KEY}_timestamp`, Date.now().toString());

    return sessionId;
};

export const clearSession = (): void => {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
    sessionStorage.removeItem(`${SESSION_STORAGE_KEY}_timestamp`);
};

export const getCurrentSessionId = (): string | null => {
    return sessionStorage.getItem(SESSION_STORAGE_KEY);
};
